import React from 'react'

import { Trash2Icon } from 'lucide-react'
import { observer } from 'mobx-react'

import { PermitActionType } from '~/client/graph'
import { IWorkflowTypeAction } from '~/client/src/shared/models/WorkflowType'

import WorkflowStepConfiguratorStore from '../../WorkflowStepConfigurator.store'
import ClosureEnd from '../actions/ClosureEnd'
import ClosureStart from '../actions/ClosureStart'
import { IActionProps } from '../actions/types'
import WorkflowActionConfiguratorStore from '../WorkflowActionConfigurator.store'

interface IProps {
  stepId: string
  stepsConfiguratorStore: WorkflowStepConfiguratorStore
  action: IWorkflowTypeAction
  store: WorkflowActionConfiguratorStore
  actionIndex: number
}

const COMPONENT_MAP: Partial<Record<PermitActionType, React.FC<IActionProps>>> =
  {
    [PermitActionType.StartClosureAction]: ClosureStart,
    [PermitActionType.EndClosureAction]: ClosureEnd,
  }

function WorkflowAction(props: IProps) {
  const { stepId, stepsConfiguratorStore, action, store, actionIndex } = props

  const Component = COMPONENT_MAP[action.type]
  if (!Component) return null

  const handleRemove = () => {
    store.removeAction(actionIndex)
  }

  const canRemove = store.canRemoveAction(action.type)

  return (
    <div className="row gap-10 y-center ml30 mt30 mb10 mw400 pa10 ba-light-grey brada4">
      <div className="flex-item">
        <Component
          action={action}
          onChange={store.updateAction}
          stepConfiguratorStore={stepsConfiguratorStore}
          store={store}
          stepId={stepId}
        />
      </div>
      {canRemove && (
        <Trash2Icon
          size={16}
          className="pointer text red"
          onClick={handleRemove}
        />
      )}
    </div>
  )
}

export default observer(WorkflowAction)
